module.exports = __webpack_public_path__ + "img/Save State_Down.5b286513.svg";